import type { ReactNode } from 'react';
import { cn } from '../cn.ts';

export interface MockBubbleProps {
  readonly children: ReactNode;
  /** `in` = người khác nói (trắng, góc trái dưới nhọn) · `out` = mình nói (brand, góc phải dưới nhọn). */
  readonly direction: 'in' | 'out';
  readonly className?: string;
}

/**
 * Bong bóng chat. Bo góc bất đối xứng lấy nguyên thiết kế (`reference.md` §3): `18 18 18 6` cho
 * chiều vào, `18 18 6 18` cho chiều ra — góc nhọn chỉ về phía người nói.
 *
 * Bốn giá trị bo góc này KHÔNG có token vì chúng là một hình dạng, không phải một bậc trong
 * thang: `--radius-card` (18) đúng cho ba góc kia nhưng góc thứ tư là 6, và gộp chúng thành một
 * token mới thì token đó chỉ có đúng một chỗ dùng.
 */
export function MockBubble({ children, direction, className }: MockBubbleProps) {
  return (
    <div
      className={cn(
        // `leading-[normal]`: thiết kế KHÔNG khai line-height ở bất kỳ đâu trong mock — nó vẽ
        // lại một UI sản phẩm dày đặc. Token 1.55 của ta là cho chữ đọc trên trang.
        'px-3.5 py-2.5 text-body-sm leading-[normal]',
        direction === 'in'
          ? 'rounded-[18px_18px_18px_6px] bg-surface text-ink-mock-900 shadow-hairline'
          : 'rounded-[18px_18px_6px_18px] bg-brand-600 text-white',
        className,
      )}
    >
      {children}
    </div>
  );
}
